import { Injectable } from '@angular/core';
import { LinkedAccount } from "../common/linked-account";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import {BehaviorSubject, Observable, throwError} from "rxjs";
import { LinkAccountRequest } from "./link-account-request";
import { CommonDataService } from "../common/common-data.service";
import { UserCredentials } from "./user-credentials";
import { catchError } from "rxjs/operators";
import {MatSnackBar} from "@angular/material/snack-bar";
import {LinkExpiryErrorComponent} from "./error/link-expiry-error.component";
import {Expiry} from "./error/link-expiry-error";

@Injectable({
  providedIn: 'root'
})
export class LinkAccountService {

  private _isLosingBundleOffer:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isLosingBundleOffer$:Observable<boolean> = this._isLosingBundleOffer.asObservable();


  get losingBundleOffer(): boolean{
    return this._isLosingBundleOffer.getValue();
  }

  set losingBundleOffer(value: boolean) {
    this._isLosingBundleOffer.next(value);
  }

  openExpiryErrorSnackBar(expiryInMinutes: number) {
    this.snackBar.openFromComponent(LinkExpiryErrorComponent, {
      data: new Expiry(expiryInMinutes),
      duration: 10000, // 10 seconds
      verticalPosition: "top"
    });
  }

  constructor(private httpClient: HttpClient, private snackBar: MatSnackBar,
              private commonDataService: CommonDataService) { }

  getLinkedAccounts(billingAccountId: string): Observable<LinkedAccount[]> {
    return this.httpClient.get<LinkedAccount[]>(`api/user/linkedAccounts/${billingAccountId}`);
  }

  linkAccount(credentials: UserCredentials): Observable<any> {
    return this.httpClient.post<any>(`api/user/linkedAccounts/link/${this.commonDataService.user.billingAccountId}`, credentials)
      .pipe(
        catchError(err => {
          if (err instanceof HttpErrorResponse && err.status === 403) {
            if (err.error && err.error.expiryInMinutes) {
              return throwError(err.error.expiryInMinutes);
            }
            return throwError(`The login credentials provided were invalid, please try again. If your username does not end in
              ${this.commonDataService.siteDetails.emailDomain} you will need to include the full domain (eg. john${this.commonDataService.siteDetails.emailDomain}).`);
          }

          return throwError(`An error occurred while linking your account. Please try again later.`);
        })
      );
  }

  unlinkAccount(linkAccountRequest: LinkAccountRequest): Observable<any> {
    return this.httpClient.post<any>(`api/user/linkedAccounts/unlink/${this.commonDataService.user.billingAccountId}`, linkAccountRequest)
      .pipe(
        catchError(() => {
          return throwError(`An error occurred while unlinking your account. Please try again later.`);
        })
      );
  }

  isLosingBundleOffer(account: string){
    return this.httpClient.get<boolean>(`api/user/isLosingBundleOffer/${account}`);
  }

}
